export const CURRENT_LOCATION_LABEL = "My Location";
